import PromiseBB from "bluebird";
/**
 * endorse the mod by the server call
 *
 * @param {string} activeGameId
 * @param {NexusT} nexus
 * @param {string} endorseStatus
 * @param {string} modId,
 * @return {boolean} isEndorsed
 *
 */
function endorseMod(nexus, gameId, nexusModId, version, endorseStatus) {
    endorseStatus = endorseStatus.toLowerCase();
    if (endorseStatus === "undecided" ||
        endorseStatus === "abstained" ||
        endorseStatus === "") {
        endorseStatus = "endorse";
    }
    else if (endorseStatus === "endorsed") {
        endorseStatus = "abstain";
    }
    return PromiseBB.resolve(nexus.endorseMod(nexusModId, version, endorseStatus, gameId)).then((result) => result.status);
}
function endorseCollection(nexus, gameId, collectionId, endorseStatus) {
    endorseStatus = endorseStatus.toLowerCase();
    if (endorseStatus === "undecided" ||
        endorseStatus === "abstained" ||
        endorseStatus === "") {
        endorseStatus = "endorse";
    }
    else if (endorseStatus === "endorsed") {
        endorseStatus = "abstain";
    }
    return PromiseBB.resolve(nexus.endorseCollection(collectionId, endorseStatus, gameId));
}
export { endorseCollection, endorseMod };
